import { useEffect } from 'react';
import { useNavigate } from 'react-router';

/**
 * DocumentManagement - Redirect to new feature locations
 *
 * This component has been deprecated as all features have moved to other pages:
 * - Templates → Faana Agents (Smart Templates tab)
 * - Reports → Insights (Reports tab)
 * - Notes → Capture > Notebook
 * - IP Catalog → Faana Agents (IP Catalogue tab)
 * - Shared Drives → Data Sources (Shared Drives tab)
 * - Prompt Management → Faana Agents (Agent Personas tab)
 * - Configuration → Data Sources (Legacy Configuration tab)
 *
 * Redirects to /faana-agents as the primary destination.
 */
export default function DocumentManagement() {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/faana-agents', { replace: true });
  }, [navigate]);

  return null;
}